// @flow
import React, { Fragment } from 'react';

import help from 'app/developer-v3/components/PartnerSupportForm/components/blocks/Help';

import {
  getUserFields,
  messageField,
} from 'app/developer-v3/components/PartnerSupportForm/content/nodes/common';
import { BASE_DOC_URL_VB } from 'app/developer-v3/constants';
import { ZAPIER_APP_BASE_URL } from 'app/common/constants';

export const createPartnerProgram = (isLoggedIn: boolean) => ({
  value: 'existing-partner-program',
  label: 'Zapier Partner Program: Co-marketing my app and more',
  zendeskCustomFieldValue: 'pcf-existing-co-marketing',
  child: help({
    docs: {
      title: 'Zapier Partner Program',
      body: () => (
        <Fragment>
          <p>
            The Zapier Integration Partner Program (accessible to public
            platform partners) and all of its benefits are free. All you have to
            do is get more users and maintain a healthy integration in order to
            access benefits!
          </p>
          <p>
            We’ll share personalized recommendations for growing your
            integration, based on what’s worked for our top partners.
          </p>
          <p>
            Our team acts as frontline support for your integration, triaging
            bugs and passing along your users’ feedback.
          </p>
          <p>
            As your integration grows, you’ll gain more benefits from the
            program.
          </p>
        </Fragment>
      ),
      links: [
        {
          href: `${ZAPIER_APP_BASE_URL}/platform/partner-program`,
          title: 'Partner Program Overview',
        },
        {
          href: `${BASE_DOC_URL_VB}/publish/partner-program`,
          title: 'About the Partner Program',
        },
        {
          href: `${BASE_DOC_URL_VB}/publish/partner-faq`,
          title: 'Zapier Partner Program tips',
        },
      ],
    },
    contact: [
      ...getUserFields(isLoggedIn),
      {
        ...messageField,
        details: `Please let us know what question you have about the Partner Program.`,
      },
    ],
  }),
});
